"use strict";
import { translateWord } from "./translateWord";
export function translate(original, options) {
  return original.replace(/[a-z]+-?/gi, (word) => translateWord(word, options));
}
